import React, { memo, Fragment } from 'react';

import { I18nText } from '../../types/general.types';

import { useTranslate } from '../../common/hooks/useTranslate';

interface TranslateProps {
  id: I18nText;
}

function Translate({ id }: TranslateProps) {
  const { t } = useTranslate();

  if (id) {
    return <Fragment>{t(id)}</Fragment>;
  }

  return null;
}

export default memo<TranslateProps>(Translate);
